import { useMediaQuery } from "@mantine/hooks";

const useScreen = () => {
  const largeScreen = useMediaQuery("(min-width: 48em)");

  return largeScreen;
};

export default useScreen;